export const getPaginatedTitle = (title, page) => {
  return `${title}${page > 1 ? ` - Page ${page}` : ''}`
}

export const convertToSlug = str => {
  return str
    .toLowerCase()
    .trim()
    .replace(/[^\w ]+/g, '')
    .replace(/ +/g, '-')
}

export const getYoutubeId = url => {
  const regExp = /(?:youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#&?]*)/
  const match = url.match(regExp)
  return match && match[1].length === 11 ? match[1] : false
}

export const redirectToHome = (res, destination) => {
  res.statusCode = 301
  res.setHeader('Location', destination)
  res.end()
}

export const getValidatedRequest = (predicate, promiseCallback, parameters) => {
  if (predicate && promiseCallback) {
    return promiseCallback(parameters)
  }
  return Promise.resolve(null)
}
